(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-mk2-alt-toggle]').forEach((button) => {
      if (button.dataset.mk2Ready === 'true') return;
      button.dataset.mk2Ready = 'true';

      button.addEventListener('click', () => {
        const card = button.closest('[data-mk2-product-card]');
        if (!card) return;

        const isAlternate = card.dataset.showAlternate === 'true';
        card.dataset.showAlternate = String(!isAlternate);
        button.setAttribute('aria-pressed', String(!isAlternate));
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
